import { buttonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const stickyActionBar = tv({
    slots: {
        root: 'bg-neutral-1/90 shadow-card fixed bottom-0 left-0 right-0 shadow-lg backdrop-blur-2xl',
        headerContainer: '',
        mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
        textContainer: 'basis-full',
        actionContainer: 'basis-full',
        helperTextSlot: 'text-body3 text-center',
        primaryActionContainer: 'flex flex-[2]',
        secondaryActionContainer: 'flex flex-1'
    },
    variants: {
        type: buttonTypeVariants,
        barType: {
            bookBar: {
                mainContainer: 'mp-2 flex flex-row items-center justify-between gap-2',
                textContainer: 'basis-full',
                actionContainer: 'basis-full'
            },
            actionBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2',
                textContainer: 'basis-full',
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        hasSecondaryAction: {
            true: {
                actionContainer: 'flex w-full flex-row gap-2'
            },
            false: {
                actionContainer: 'flex w-full'
            }
        }
    },
    compoundVariants: [
        {
            barType: 'actionBar',
            hasSecondaryAction: true,
            class: {
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        {
            barType: 'actionBar',
            hasSecondaryAction: false,
            class: {
                actionContainer: 'flex w-full'
            }
        }
    ],
    defaultVariants: {
        type: 'primary',
        barType: 'actionBar',
        hasSecondaryAction: false
    }
});
export { stickyActionBar };
